import { Injectable } from '@angular/core';
import { ActividadBase, Actividad, Tarea } from '@app/shared';
import { StorageService } from './storage.service';
import { findIndex } from 'lodash';
import { Logger } from '@app/core';
import { HelperFlowService } from '@app/flow';

const log = new Logger('ManageActivityService');

/**
 * Administra todo lo relacionado con las actividades,
 * en la automatización de procesos.
 *
 * @export
 * @class ManageActivityService
 */
@Injectable()
export class ManageActivityService {
  // Estados de las actividades
  status: ActividadBase[];
  // Todas las tareas de las actividades del flujo
  allTasks: Tarea[] = [];
  // Copia de las 'actividades' del flujo consultado
  activities: Actividad[];

  constructor(
    protected ss: StorageService,
    private hfs: HelperFlowService,
  ) {
    // Consultar las actividades del flujo actual
    this.ss.getActivities().subscribe(data => {
      this.activities = data;
      let alltasks: Tarea[] = [];
      data.map(a => {
        alltasks = [...alltasks, ...a.tareas];
      });
      this.allTasks = alltasks;
    });
  }

  /**
   * Retorna las actividades refinadas(con metadatos).
   *
   * @returns
   * @memberof ManageActivityService
   */
  getRefineActivities() {
    return this.hfs.refineActivities(this.activities);
  }

  /**
   * Actualizar la información de una actividad existente.
   *
   * @param {Actividad} activity
   * @param {boolean} [skipRegisterAction=false]
   * @returns {boolean}
   * @memberof ManageActivityService
   */
  edit(activity: Actividad): boolean {
    const indexOldActivity = findIndex(this.activities, { id: Number(activity.id) });
    if (indexOldActivity !== -1) {
      // Actualizar actividad en memoria
      this.activities[indexOldActivity] = activity;
      // Guardar cambios en LocalStorage
      this.saveInLocal();
      return true;
    }
    return false;
  }

  /**
   *  Autoriza el almacenamiento de las actividades en LocalStorage.
   *
   * @private
   * @memberof ManageActivityService
   */
  saveInLocal() {
    this.ss.setActivities(this.activities);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/basic-process-configuration/shared/manage-activity.service.ts